var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"nav-item",class:{
    active: _vm.active,
    'nav-item-reverse': _vm.iconOnRight,
    loading: _vm.loading,
  }},!_vm.loading && _vm.$listeners),[(!_vm.loading)?_c('span',{class:{ pulse: _vm.pulse }},[_c('i',{staticClass:"icon",class:("" + _vm.icon)})]):_vm._e(),(_vm.loading)?_c('span',{staticClass:"d-inline-flex p-1"},[_c('HMSpinner',{staticClass:"spinner"})],1):_vm._e(),_c('span',{staticClass:"text ml-md-2 mr-2",class:{ 'text--show-on-mobile': _vm.showTextOnMobile }},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }